import { useEffect, useRef, useState } from "react";
import { Play } from "lucide-react";
import { FDA } from "@/data/content";

const reduced = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
const mobile = () => window.matchMedia?.("(max-width: 767px)").matches;
let current = null;

const claim = (v) => {
  if (mobile() && current && current !== v) current.pause();
  current = v;
};

export const LazyVideo = ({ media, testId, caption = true, light = false, className = "" }) => {
  const ref = useRef(null);
  const [near, setNear] = useState(false);
  const [manual, setManual] = useState(false);
  const inView = useRef(false);
  const still = reduced();
  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setNear(true);
      inView.current = e.intersectionRatio >= 0.5;
      if (still && !manual) return;
      if (e.intersectionRatio >= 0.5) { claim(v); v.play?.().catch(() => {}); } else v.pause?.();
    }, { threshold: [0, 0.5], rootMargin: "200px 0px" });
    io.observe(v);
    return () => { io.disconnect(); if (current === v) current = null; };
  }, [still, manual]);
  const start = () => { setManual(true); setNear(true); const v = ref.current; claim(v); setTimeout(() => v.play?.().catch(() => {}), 0); };
  return (
    <figure data-testid={testId} className={className}>
      <div className="relative aspect-[9/16] overflow-hidden rounded-3xl bg-navy shadow-[0_12px_32px_rgba(11,35,64,0.18)]">
        <video ref={ref} src={near ? media.src : undefined} poster={near ? media.poster : undefined} muted loop playsInline preload="none" autoPlay={!still}
          aria-label={media.label} onPlay={(e) => (inView.current || manual ? claim(e.currentTarget) : e.currentTarget.pause())} controls={still && manual} className="absolute inset-0 h-full w-full object-cover" data-testid={`${testId}-video`} />
        {still && !manual && (
          <button type="button" onClick={start} data-testid={`${testId}-play`} aria-label={`Play ${media.label}`}
            className="absolute inset-0 m-auto grid h-16 w-16 place-items-center rounded-full bg-sunny text-navy shadow-lg"><Play className="h-7 w-7" /></button>
        )}
      </div>
      {caption && <figcaption data-testid={`${testId}-fda`} className={`mt-2 text-[11px] leading-snug ${light ? "text-sand/80" : "text-slate-600"}`}>*{FDA}</figcaption>}
    </figure>
  );
};
